import * as React from 'react';
import * as Redux from 'redux';
import * as _ from 'lodash';
import { IGlobalSort } from '../../../state-helpers/sort';
import { isNullOrUndefined } from 'util';

export interface ISortProps<T> {
    sort: IGlobalSort<T>;
    sortGroupName: string;
    activeSortDirection?: number;
}

export interface ISortGroupProps<T> {
    sortGroupName: string;
    sorts: IGlobalSort<T>[];
    onSort?: (sort: IGlobalSort<T>) => void;
    customClasses?: string;
    twoDimensional?: boolean;
    activeSortDirection?: number;
}

/// <summary>
/// This component creates a sort group
/// T is the item type that will be sorted
/// </summary>
/// <param name="sortGroupName">A unique identifier for the sort group</param>
/// <param name="sorts">Array of IGlobalSort objects corresponding to sorts</param>
/// <param name="onSort">The callback function for when the user selects a new sort (optional)</param>
export class SortGroup<T> extends React.Component<ISortGroupProps<T>, any> {
    static defaultProps = {
        onSort: (sort) => { },
        customClasses: ''
    }

    OnChange(newId: string) {
        let sort = _.find(this.props.sorts, (s) => s.sortId === newId);
        this.props.onSort(sort);
    }

    OnClick(element: HTMLElement) {
        if (element.tagName.toLowerCase() === 'input') {
            let sort = _.find(this.props.sorts, (s) => s.sortId === element.id);
            this.props.onSort(sort);
        }
    }

    render() {
        const { sorts, sortGroupName, customClasses, twoDimensional, activeSortDirection } = this.props;
        //let boundOnChange = this.OnChange.bind(this);
        return (
            <div className={'global-sort ' + customClasses}>
                {sorts &&
                    <fieldset onChange={(ev) => !twoDimensional && this.OnChange((ev.target as any).id)} onClick={(ev) => twoDimensional && this.OnClick(ev.target as HTMLElement)}
                    ref="fieldset">
                        <div className="global-sort-list">
                            {this.props.sorts.map((s, i) =>
                                <Sort
                                key={s.sortId}
                                sort={s}
                                sortGroupName={sortGroupName}
                                activeSortDirection={activeSortDirection}
                                />)}
                        </div>
                    </fieldset>}
            </div>
        );
    }
}

/// <summary>
/// This component represents a single sort in a sort group
/// T is the item type that will be sorted
/// </summary>
/// <param name="sort">The ISort object corresponding to this sort</param>
/// <param name="selected">Boolean, indicates whether sort is selected</param>
/// <param name="sortGroupName">The unique identifier for the sort group</param>
export class Sort<T> extends React.Component<ISortProps<T>, any> {
    render() {
        const { sort, sortGroupName, activeSortDirection } = this.props;
      
        return (
            <div className={"global-sort-list-item "
                + (sort.inactive ? "disabled " : "")
                + (sort.selected ? `active ${!isNullOrUndefined(activeSortDirection) ? (activeSortDirection === 1 ? 'descending' : 'ascending  ') : ''}` : "")} >
                <input type="radio" readOnly value={sort.sortId} id={sort.sortId} checked={sort.selected} name={sortGroupName} disabled={sort.inactive} />
                <label htmlFor={sort.sortId}>{sort.display} <svg className="global-sort-list-item-sorts">
                    <use xlinkHref="#icon-sort"></use>
                </svg></label>
                
            </div>
        );
    }
}